enum NativeDateType {
  DATE = 'date',
  MONTH = 'month',
  DATETIME_LOCAL = 'datetime-local',
  TIME = 'time',
}

export default NativeDateType;
